import { createAction, props } from '@ngrx/store';
import {CotsType, GlobalConfig, Organization, ShapeType} from "../../models/global-config.models";
import {MaterialFamily} from "../../models/materials.model";

export const loadMaterialFamilies = createAction('[GlobalConfigDropdown Data Access] LoadMaterialFamilies');
export const loadMaterialFamiliesSuccess = createAction(
  '[GlobalConfigDropdown Data Access] loadMaterialFamiliesSuccess',
  props<{ materialFamilies: MaterialFamily[] }>()
);
export const loadMaterialFamiliesFailure = createAction(
  '[GlobalConfigDropdown Data Access] loadMaterialFamiliesFailure',
  props<{ error: string }>()
);

export const loadOrganizations = createAction('[GlobalConfigDropdown Data Access] LoadOrganizations');
export const loadOrganizationsSuccess = createAction(
  '[GlobalConfigDropdown Data Access] LoadOrganizationsSuccess',
  props<{ organizations: Organization[] }>()
);
export const loadOrganizationsFailure = createAction(
  '[GlobalConfigDropdown Data Access] LoadOrganizationsFailure',
  props<{ error: string }>()
);

export const loadShapeTypes = createAction('[GlobalConfigDropdown Data Access] LoadShapeTypes');
export const loadShapeTypesSuccess = createAction(
  '[GlobalConfigDropdown Data Access] LoadShapeTypesSuccess',
  props<{ shapeTypes: ShapeType[] }>()
);
export const loadShapeTypesFailure = createAction(
  '[GlobalConfigDropdown Data Access] LoadShapeTypesFailure',
  props<{ error: string }>()
);

export const loadCotsTypes = createAction('[GlobalConfigDropdown Data Access] LoadCotsTypes');
export const loadCotsTypeSuccess = createAction(
  '[GlobalConfigDropdown Data Access] Load CotsTypes Success',
  props<{ cotsTypes: CotsType[] }>()
);
export const loadCotsTypeFailure = createAction(
  '[GlobalConfigDropdown Data Access] Load CotsTypes Failure',
  props<{ error: string }>()
);




